module.exports = __webpack_public_path__ + "static/media/14.07ce83e2.jpg";